var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-header-mobile-menu-prefooter"},[_c('div',{staticClass:"common-header-mobile-menu-prefooter__socials"},_vm._l((_vm.contacts.socials),function(item,index){return _c('a',{key:index,staticClass:"common-header-mobile-menu-prefooter__socials-item",attrs:{"href":item.href}},[_c('icon',{attrs:{"name":item.icon}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }